import { Grid } from '@mui/material';
import Lottie from 'lottie-react';
import React from 'react'
import TryoAnim from "../../assets/animations/TryoAnim.json";
import styles from './LoadingView.module.scss';

const LoadingView = ({ fixed = false }) => {
  const options = {
    animationData: TryoAnim,
    loop: true,
    autoplay: true,
  };

  const style = {
    width: 300
  }

  return (
    <>
      <Grid container justifyContent={"center"} alignItems={"center"} height={"100%"} className={fixed ? styles.loading : ''}>
        <Lottie style={style} {...options}></Lottie>
      </Grid>
    </>
  )
}

export default LoadingView